// extracted by mini-css-extract-plugin
export default {"root":"UploadTask_root__FdUt2","uploadContainer":"UploadTask_uploadContainer__N4L4P"};